import axios from "axios";
import { auth } from "@/utils/firebase";

const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_FIREBASE_FUNCTIONS_DEV_URL
    : process.env.REACT_APP_FIREBASE_FUNCTIONS_BASE_URL;

// Custom API Client
const apiClient = axios.create({ baseURL });

const getToken = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      try {
        if (user) {
          const token = await user.getIdToken(true);
          resolve(token);
        } else {
          resolve(null);
        }
      } catch (error) {
        reject(error);
      } finally {
        unsubscribe();
      }
    });
  });
};

// Request interceptor to refresh token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      config.headers["Content-Type"] = "application/json";
      return config;
    } catch (error) {
      console.error("Error refreshing token: ", error);
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
